import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full p-3 fill-height overflow-y-auto" }
const _hoisted_2 = { class: "chat-messages" }
const _hoisted_3 = { class: "chat-message-avatar" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "chat-message-content" }
const _hoisted_6 = { class: "chat-message-content-text" }
const _hoisted_7 = { class: "chat-message-content-attachments" }
const _hoisted_8 = {
  key: 0,
  class: "chat-input-attachments d-flex flex-column gap-1 mb-2"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "pr-2" }
const _hoisted_12 = { class: "d-flex flex-column" }
const _hoisted_13 = { class: "font-weight-bold chat-input-attachment-title" }
const _hoisted_14 = { class: "chat-input-attachment-ext" }
const _hoisted_15 = { class: "w-full p-3" }
const _hoisted_16 = { class: "chat-message-participants" }
const _hoisted_17 = { class: "table table-borderless w-100 mt-5 mb-0 chat-message-participants" }
const _hoisted_18 = { class: "py-1 px-0" }
const _hoisted_19 = { class: "d-flex align-center" }
const _hoisted_20 = { class: "pr-2" }
const _hoisted_21 = ["src", "alt"]
const _hoisted_22 = { class: "font-weight-bold" }
const _hoisted_23 = { class: "chat-input-container d-flex" }
const _hoisted_24 = { class: "d-flex align-end" }
const _hoisted_25 = { class: "chat-input-attachments d-flex flex-column gap-2" }
const _hoisted_26 = { class: "pr-2" }
const _hoisted_27 = { class: "d-flex flex-column" }
const _hoisted_28 = { class: "font-weight-bold chat-input-attachment-title" }
const _hoisted_29 = { class: "chat-input-attachment-ext" }
const _hoisted_30 = { class: "chat-input-remove-icon" }
const _hoisted_31 = { class: "d-flex flex-column justify-end" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = { class: "d-flex align-end" }
const _hoisted_34 = { class: "chat-input-backdrop" }

import { ref, onMounted } from 'vue'
import LiveChatMessage from '../../../api/v2/models/live_chat_message'
import api from '../../../api/v2/api'
import { makeChannel } from '../../../../action_cable/cable'
import LiveChatMessageForm from '../../../api/v2/forms/live_chat_message'
import FileIcon from '../atoms_molecules/FileIcon.vue'
import AttachmentForm from "../../../api/v2/forms/attachment"
import Axios from "axios"
import url_path from "../../../../helpers/url_helper"
import LiveChatParticipant from "../../../api/v2/models/live_chat_participant"

interface AttachmentType {
  isDeleted: boolean
  isUploadCompleted: boolean
  serverId: string | null
  progressPercentage: number
  file: File
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LiveChat',
  props: {
    targetableType: { default: 'Lesson' },
    targetableId: {}
  },
  setup(__props: any) {

const props = __props

const chanel = ref<any>(null)
const isDragging = ref(false)
const messages = ref<LiveChatMessage[]>([])
const chatContent = ref('')
const attachments = ref<AttachmentType[]>([])
const inProgress = ref(false)
const showParticipantDialog = ref(false)
const totalParticipants = ref(0)
const participants = ref<LiveChatParticipant[]>([])
const file = ref<HTMLInputElement | null>(null)
const chatInput = ref<HTMLTextAreaElement | null>(null)

const scrollToLast = () => {
  setTimeout(() => {
    let lastMessage = document.querySelector("#last-message") as HTMLElement
    if (lastMessage) {
      lastMessage.scrollIntoView({ behavior: 'smooth', block: 'end' })
    }
  }, 100)
}

const createChannel = () => {
  chanel.value = makeChannel(
    'LiveChatChannel',
    async (e: any) => {
      if (e.message) {
        const message = new LiveChatMessage(e.message)
        messages.value.push(message)
      }

      if (e.participants_count) {
        totalParticipants.value = e.participants_count
      }

      scrollToLast()
    },
    () => {
      chanel.value.send({
        action: 'follow',
        data: {
          targetable_id: props.targetableId,
          targetable_type: props.targetableType
        }
      })
    },
  )
}

const autoExpandTextarea = () => {
  const textarea = document.getElementById('chat-input') as HTMLTextAreaElement
  if (textarea) {
    textarea.style.height = 'auto'
    textarea.style.height = textarea.scrollHeight + 'px'
  }
}

const getFileName = (attachment: AttachmentType) => {
  return getFileNameFromString(attachment.file.name)
}

const getFileNameFromString = (string: string) => {
  return string.replace(/\.[^/.]+$/, "")
}

const getFileExt = (attachment: AttachmentType) => {
  return getFileExtFromString(attachment.file.name)
}

const getFileExtFromString = (string: string) => {
  return string.split('.').pop()?.toUpperCase() || ''
}

const addAttachment = () => {
  file.value?.click()
}

const handleUpload = async (attachment: AttachmentType) => {
  const attachmentForm = new AttachmentForm()
  attachmentForm.filename = attachment.file.name

  const attachmentRes = await api.attachment.create(attachmentForm)

  const parseProgress = (progressEvent: any) => {
    const progressPercentage =
      (progressEvent.loaded / progressEvent.total) * 100
    if (progressPercentage > 98) {
      attachment.progressPercentage = 98
    } else if (progressPercentage > 5) {
      attachment.progressPercentage = progressPercentage
    }
  }

  const res = await Axios.put(attachmentRes.uploadUrl, attachment.file, {
    headers: {
      'Content-Type': attachment.file.type,
      'Content-Disposition': `attachment; filename=${attachment.file.name}`
    },
    onUploadProgress: parseProgress
  })

  if (res.status === 200) {
    attachment.isUploadCompleted = true
    attachment.serverId = String(attachmentRes.id)
  } else {
    return alert("Error: Upload failed!")
  }
}

const deleteAttachment = (index: number) => {
  attachments.value[index].isDeleted = true
}

const canSubmit = () => {
  return chatContent.value.trim() != "" || attachments.value.filter(attachment => !attachment.isDeleted && attachment.isUploadCompleted).length
}

const handleFileChange = () => {
  if (!file.value?.files) return
  
  Array.from(file.value.files).forEach((f) => {
    if (attachments.value.find((attachment) => attachment.file.name === f.name && attachment.file.size === f.size)) {
      return
    }

    const attachment: AttachmentType = {
      isDeleted: false,
      isUploadCompleted: false,
      serverId: null,
      progressPercentage: 5,
      file: f as File
    }

    if (/png|jpeg|jpg/.test(attachment.file.type) && (10 * 1024 * 1024 < attachment.file.size)) {
      alert("Limit 10 MB per image.")
      return
    } else if (20 * 1024 * 1024 < attachment.file.size) {
      alert("Limit 20 MB per file.")
      return
    }

    attachments.value.push(attachment)
    handleUpload(attachment)
  })
}

const handleEnterChatForm = (e: KeyboardEvent) => {
  if (e.key === 'Enter' && !e.shiftKey && !e.isComposing && e.keyCode !== 229) {
    e.preventDefault()
    if (canSubmit()) createMessage()
    return false
  }
}

const dragover = (e: DragEvent) => {
  e.preventDefault()
  isDragging.value = true
}

const dragleave = () => {
  isDragging.value = false
}

const drop = (e: DragEvent) => {
  if (file.value && e.dataTransfer) {
    file.value.files = e.dataTransfer.files
  }
  handleFileChange()
  isDragging.value = false
  e.preventDefault()
}

const createMessage = () => {
  if (!canSubmit()) return

  inProgress.value = true
  let input = (document.getElementById('chat-input') as HTMLInputElement)

  const messageForm = new LiveChatMessageForm()
  messageForm.content = input.value
  messageForm.targetableId = parseInt(props.targetableId)
  messageForm.targetableType = props.targetableType
  messageForm.attachmentIds = attachments.value.filter((attachment) =>
    !attachment.isDeleted && attachment.serverId
  ).map((attachment) => parseInt(attachment.serverId!))

  api.liveChatMessage.create(messageForm)
    .then(() => {
      chatContent.value = ''
      attachments.value = []
      setTimeout(() => input.focus(), 200)
      input.style.setProperty("height", "unset")
    })
    .catch(() => {
      alert("Error: Send message failed!")
    })
    .finally(() => {
      inProgress.value = false
    })
}

const openUrl = (url: string) => {
  window.open(url, "_blank")
}

const openParticipants = async () => {
  showParticipantDialog.value = true
  participants.value = await api.liveChatMessage.participants({
    targetableId: props.targetableId,
    targetableType: props.targetableType,
  })
}

onMounted(async () => {
  const data = await api.liveChatMessage.index({
    targetableId: props.targetableId,
    targetableType: props.targetableType,
  })
  messages.value = data.messages
  totalParticipants.value = data.participantsCount
  scrollToLast()
  createChannel()
  
  document.getElementById('chat-input')?.addEventListener('input', autoExpandTextarea)
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "live-chat-container flex-grow-1 d-flex flex-column justify-content-between",
    onDragover: dragover,
    onDragleave: dragleave,
    onDrop: drop
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "chat-message d-flex"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("img", {
                src: message.userAvatar,
                alt: message.userName + ' avatar'
              }, null, 8 /* PROPS */, _hoisted_4)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("strong", null, _toDisplayString(message.userName), 1 /* TEXT */),
                _createTextVNode(": " + _toDisplayString(message.content), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_7, [
                (message.attachments.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.attachments, (attachment, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                          (['PNG', 'JPG', 'JPEG'].includes(getFileExtFromString(attachment.filename)))
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: attachment.url,
                                alt: "image",
                                class: "message-attachment-image"
                              }, null, 8 /* PROPS */, _hoisted_9))
                            : (_openBlock(), _createElementBlock("div", {
                                key: index,
                                class: "chat-input-attachment-container"
                              }, [
                                _createElementVNode("div", {
                                  class: "chat-input-attachment d-flex",
                                  onClick: ($event: any) => (openUrl(attachment.url))
                                }, [
                                  _createElementVNode("div", _hoisted_11, [
                                    _createVNode(FileIcon, {
                                      fileName: attachment.filename
                                    }, null, 8 /* PROPS */, ["fileName"])
                                  ]),
                                  _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, _toDisplayString(getFileNameFromString(attachment.filename)), 1 /* TEXT */),
                                    _createElementVNode("div", _hoisted_14, _toDisplayString(getFileExtFromString(attachment.filename)), 1 /* TEXT */)
                                  ])
                                ], 8 /* PROPS */, _hoisted_10)
                              ]))
                        ], 64 /* STABLE_FRAGMENT */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]))
        }), 128 /* KEYED_FRAGMENT */)),
        _cache[5] || (_cache[5] = _createElementVNode("div", { id: "last-message" }, null, -1 /* CACHED */))
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _cache[8] || (_cache[8] = _createTextVNode(" This live is watching by ", -1 /* CACHED */)),
        _createVNode(_component_v_btn, {
          plain: "",
          class: "p-0 participant-btn",
          onClick: openParticipants
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(totalParticipants.value) + " people", 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        _cache[9] || (_cache[9] = _createTextVNode(". ", -1 /* CACHED */)),
        _createVNode(_component_v_dialog, {
          modelValue: showParticipantDialog.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showParticipantDialog).value = $event)),
          "max-width": "800"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode("Participants", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_card_text, { class: "d-flex px-6" }, {
                  default: _withCtx(() => [
                    _createElementVNode("table", _hoisted_17, [
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(participants.value, (participant) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: participant.id,
                            class: "text-caption"
                          }, [
                            _createElementVNode("td", _hoisted_18, [
                              _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, [
                                  _createElementVNode("img", {
                                    src: participant.avatar,
                                    alt: participant.name + ' avatar',
                                    class: "avatar",
                                    style: {"width":"35px","height":"35px"}
                                  }, null, 8 /* PROPS */, _hoisted_21)
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_22, _toDisplayString(participant.name), 1 /* TEXT */)
                                ])
                              ])
                            ])
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ])
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (showParticipantDialog.value = false))
                    }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("近い", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_v_btn, {
            plain: "",
            icon: true,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (addAttachment())),
            disabled: inProgress.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("mdi-attachment", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled"])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(`d-flex flex-column w-full justify-center ${ attachments.value.length ? 'gap-1' : '' }`)
        }, [
          _createElementVNode("div", _hoisted_25, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attachments.value, (attachment, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(`chat-input-attachment-container ${attachment.isDeleted ? 'd-none' : ''}`)
              }, [
                (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "chat-input-attachment d-flex"
                }, [
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(FileIcon, {
                      fileName: attachment.file.name
                    }, null, 8 /* PROPS */, ["fileName"])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, _toDisplayString(getFileName(attachment)), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_29, _toDisplayString(getFileExt(attachment)), 1 /* TEXT */)
                  ])
                ])),
                _createElementVNode("div", {
                  class: "chat-input-progress-bar",
                  style: _normalizeStyle({
                    width: `${attachment.progressPercentage}%`,
                    display: `${attachment.isUploadCompleted ? 'none' : 'block'
                  }`})
                }, null, 4 /* STYLE */),
                _createElementVNode("div", _hoisted_30, [
                  _withDirectives(_createVNode(_component_v_btn, {
                    variant: "outlined",
                    icon: true,
                    onClick: ($event: any) => (deleteAttachment(index))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode("mdi-close", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"]), [
                    [_vShow, !inProgress.value]
                  ])
                ])
              ], 2 /* CLASS */))
            }), 256 /* UNKEYED_FRAGMENT */))
          ]),
          _createElementVNode("div", _hoisted_31, [
            _withDirectives(_createElementVNode("textarea", {
              ref_key: "chatInput",
              ref: chatInput,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((chatContent).value = $event)),
              id: "chat-input",
              placeholder: "内容を入力してください",
              rows: "1",
              onKeydown: handleEnterChatForm,
              disabled: inProgress.value
            }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_32), [
              [_vModelText, chatContent.value]
            ])
          ])
        ], 2 /* CLASS */),
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_v_btn, {
            plain: "",
            disabled: !canSubmit(),
            icon: true,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (createMessage()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode("mdi-send", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled"])
        ])
      ]),
      _withDirectives(_createElementVNode("input", {
        ref_key: "file",
        ref: file,
        type: "file",
        multiple: "",
        class: "hidden",
        onChange: handleFileChange,
        accept: ".jpg, .jpeg, .png"
      }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
        [_vShow, false]
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_34, [...(_cache[13] || (_cache[13] = [
      _createStaticVNode("<div class=\"d-flex align-center\"><div class=\"d-flex flex-column justify-center align-center chat-input-drag-message\"><div class=\"mb-3\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 132 108\" fill=\"none\" width=\"132\" height=\"108\"><g clip-path=\"url(#clip0_3605_64419)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M25.2025 29.3514C10.778 33.2165 8.51524 37.1357 11.8281 49.4995L13.4846 55.6814C16.7975 68.0453 20.7166 70.308 35.1411 66.443L43.3837 64.2344C57.8082 60.3694 60.0709 56.4502 56.758 44.0864L55.1016 37.9044C51.7887 25.5406 47.8695 23.2778 33.445 27.1428L29.3237 28.2471L25.2025 29.3514ZM18.1944 42.7244C18.8572 41.5764 20.325 41.1831 21.4729 41.8459L27.3517 45.24C28.4996 45.9027 28.8929 47.3706 28.2301 48.5185L24.836 54.3972C24.1733 55.5451 22.7054 55.9384 21.5575 55.2757C20.4096 54.613 20.0163 53.1451 20.6791 51.9972L22.8732 48.1969L19.0729 46.0028C17.925 45.3401 17.5317 43.8723 18.1944 42.7244ZM29.4091 56.3843C29.066 55.104 29.8258 53.7879 31.1062 53.4449L40.3791 50.9602C41.6594 50.6172 42.9754 51.377 43.3184 52.6573C43.6615 53.9376 42.9017 55.2536 41.6214 55.5967L32.3485 58.0813C31.0682 58.4244 29.7522 57.6646 29.4091 56.3843Z\" fill=\"#AFC1FF\"></path></g><g clip-path=\"url(#clip1_3605_64419)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M86.8124 13.4036C81.0973 11.8722 78.5673 13.2649 77.0144 19.0603L68.7322 49.97C67.1793 55.7656 68.5935 58.2151 74.4696 59.7895L97.4908 65.958C103.367 67.5326 105.816 66.1184 107.406 60.1848L115.393 30.379C115.536 29.8456 115.217 29.2959 114.681 29.16C113.478 28.8544 112.435 28.6195 111.542 28.4183C106.243 27.2253 106.22 27.2201 109.449 20.7159C109.73 20.1507 109.426 19.4638 108.816 19.3004L86.8124 13.4036ZM87.2582 28.4311C86.234 28.1567 85.1812 28.7645 84.9067 29.7888C84.6323 30.813 85.2401 31.8658 86.2644 32.1403L101.101 36.1158C102.125 36.3902 103.178 35.7824 103.453 34.7581C103.727 33.7339 103.119 32.681 102.095 32.4066L87.2582 28.4311ZM82.9189 37.2074C83.1934 36.1831 84.2462 35.5753 85.2704 35.8497L100.107 39.8252C101.131 40.0996 101.739 41.1524 101.465 42.1767C101.19 43.201 100.137 43.8088 99.1132 43.5343L84.2766 39.5589C83.2523 39.2844 82.6445 38.2316 82.9189 37.2074ZM83.2826 43.2683C82.2584 42.9939 81.2056 43.6017 80.9311 44.626C80.6567 45.6502 81.2645 46.703 82.2888 46.9775L89.7071 48.9652C90.7313 49.2396 91.7841 48.6318 92.0586 47.6076C92.333 46.5833 91.7252 45.5305 90.7009 45.256L83.2826 43.2683Z\" fill=\"#7989FF\"></path></g><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M40.4004 71.8426C40.4004 57.2141 44.0575 53.5569 61.1242 53.5569H66.0004H70.8766C87.9432 53.5569 91.6004 57.2141 91.6004 71.8426V79.1569C91.6004 93.7855 87.9432 97.4426 70.8766 97.4426H61.1242C44.0575 97.4426 40.4004 93.7855 40.4004 79.1569V71.8426ZM78.8002 67.4995C78.8002 70.1504 76.6512 72.2995 74.0002 72.2995C71.3492 72.2995 69.2002 70.1504 69.2002 67.4995C69.2002 64.8485 71.3492 62.6995 74.0002 62.6995C76.6512 62.6995 78.8002 64.8485 78.8002 67.4995ZM60.7204 70.8597C60.2672 70.2553 59.5559 69.8997 58.8004 69.8997C58.045 69.8997 57.3337 70.2553 56.8804 70.8597L47.2804 83.6597C46.4851 84.72 46.7 86.2244 47.7604 87.0197C48.8208 87.8149 50.3251 87.6 51.1204 86.5397L58.8004 76.2997L66.4804 86.5397C66.8979 87.0962 67.5363 87.4443 68.2303 87.4936C68.9243 87.5429 69.6055 87.2887 70.0975 86.7967L74.8004 82.0938L79.5034 86.7967C80.4406 87.734 81.9602 87.734 82.8975 86.7967C83.8347 85.8595 83.8347 84.3399 82.8975 83.4026L76.4975 77.0026C75.5602 76.0653 74.0406 76.0653 73.1034 77.0026L68.6601 81.4459L60.7204 70.8597Z\" fill=\"#3C46FF\"></path><defs><clipPath id=\"clip0_3605_64419\"><rect width=\"56\" height=\"56\" fill=\"white\" transform=\"translate(0 26.9939) rotate(-15)\"></rect></clipPath><clipPath id=\"clip1_3605_64419\"><rect width=\"64\" height=\"64\" fill=\"white\" transform=\"translate(69.5645 0.5) rotate(15)\"></rect></clipPath></defs></svg></div><div><h3>追加してみましょう</h3><h4>会話に追加するファイルをここにドロップしてください</h4></div></div></div>", 1)
    ]))], 512 /* NEED_PATCH */), [
      [_vShow, isDragging.value]
    ])
  ], 32 /* NEED_HYDRATION */))
}
}

})